(function ($) {
    $(function () {
        /**********************************
         *
         * スクローラー
         *
         **********************************/
        //        $("a[data-scroller]").on("click", function (e) {
        //            var target = $(this).attr("href");
        //            var y = $(target).offset().top - 55;
        //            $('html,body').animate({scrollTop: y}, 300);
        //            return false;
        //        });

        $('a[href^="#"]').on("click", (e) => {

            let target = $(e.currentTarget).attr("href");
            let y = $(target).offset().top;
            let current_pos = document.documentElement.scrollTop;
//            let is_forward = y > current_pos;
//            y += is_forward ? -500 : 200;
            y -= 300;

            $('html,body').animate({scrollTop: y}, 300);

            //            $('html,body').animate({scrollTop: y}, 100, 'linear', () => {
//
//                y += is_forward ? 100 : -200;
//                $('html,body').animate({scrollTop: y}, 450);
//
//                return false;
//            });

            return false;
        });
    });
})(jQuery);